import { render, staticRenderFns } from "./physiologyYoyo.vue?vue&type=template&id=377858d2&"
import script from "./physiologyYoyo.js?vue&type=script&lang=js&"
export * from "./physiologyYoyo.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports